import { Injectable, ErrorHandler } from '@angular/core';

import { environment } from '@env/environment';

import { MonitoringService } from './monitoring.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private monitoringService: MonitoringService) {
    super();
  }

  handleError(error: Error) {
    if (!environment.production) {
      console.error(error);
    }
    this.monitoringService.logException(error); // Manually log exception
  }
}
